<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE FAR REACHES</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="dedication"><a id="page_v"></a>To Linda, my island girl, and Carl, who has shared many an adventure, and his father, who waded across that awful lagoon<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4f889ea3